import { render } from "./ProposalCreateSearchResult.vue?vue&type=template&id=8d24683a&scoped=true"
import script from "./ProposalCreateSearchResult.vue?vue&type=script&lang=js"
export * from "./ProposalCreateSearchResult.vue?vue&type=script&lang=js"

import "./ProposalCreateSearchResult.vue?vue&type=style&index=0&id=8d24683a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d24683a"]])

export default __exports__